import { createApp } from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import router from "./router";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const app = createApp(App)
app.use(VueSweetalert2);
app.use(router)
app.mount('#app');
// const app = Vue.createApp({})

// app.use(router)

// app.mount('#app')

// createApp(App).use(router).mount('#app')
